import { ChevronRight } from "lucide-react";

export function ThinkingBar({ text, complete }: { text: string; complete: boolean }) {
  return (
    <div className="pk-thinking-bar">
      <span className={complete ? "pk-thinking-dot pk-thinking-dot--complete" : "pk-thinking-dot"} aria-hidden />
      <button type="button">
        <span>{text}</span>
        <ChevronRight size={15} />
      </button>
    </div>
  );
}
